import Vue from "vue";
import VConsole from "vconsole";
import App from "./App.vue";
import router from "./router/index";
import store from "./store/index";

// 仅在测试、预发环境启用调试面板，生产环境不显示
// build 打包后 NODE_ENV 固定为 production，需结合域名判断
function shouldEnableVConsole() {
  if (process.env.NODE_ENV !== "production") {
    return true;
  }
  const hostname = window.location.hostname;
  return /(?:^|[.-])(?:test|pre|dev|localhost|127\.0\.0\.1)(?:[.-]|$)/i.test(
    hostname
  );
}

if (shouldEnableVConsole()) {
  new VConsole();
}

// 进度条
import "nprogress/nprogress.css";
// iview主题样式
import "@/assets/style/iview/theme.less";
// 自定义全局样式
import "@/assets/style/global/index.less";

import "amfe-flexible";
import "@/utils/int.ts";

// import "default-passive-events";

import "@/utils/directives";

import Directives from "@/utils/inputTopView";
Vue.use(Directives);

import PAGE_API from "@/apis/pageApi";
import HTTP_API from "@/apis/httpApi";
// import videojs from "video.js";
// import "video.js/dist/video-js.css";
// Vue.prototype.$video = videojs;
// 全局引入bridge
// import VueWechatTitle from "vue-wechat-title";
// Vue.use(VueWechatTitle);
import Bridge from "@/utils/bridge";
Vue.prototype.$bridge = Bridge;
import VueClipBoard from "vue-clipboard2";

Vue.use(VueClipBoard);
import fn from "@/utils/fn.ts";
fn.getUrlData();
import Component from "vue-class-component";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/css/swiper.css";
function px2rem(px) {
  if (/%/gi.test(px)) {
    return px;
  } else {
    return parseFloat(px) / 75 + "rem";
  }
}
Vue.prototype.$px2rem = px2rem;
Vue.use(VueAwesomeSwiper);
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);
import {
  Button,
  Image as VanImage,
  NoticeBar,
  Swipe,
  SwipeItem,
  Progress,
  ActionSheet,
  Tab,
  Tabs,
  NavBar,
  Empty,
  Badge,
  Sticky,
  Collapse,
  CollapseItem,
  Overlay,
  Popover,
  PullRefresh,
  List,
  ShareSheet,
  Loading,
  CountDown,
  Search,
} from "vant";
Vue.use(Button)
  .use(VanImage)
  .use(NoticeBar)
  .use(Swipe)
  .use(SwipeItem)
  .use(Progress)
  .use(ActionSheet)
  .use(Tab)
  .use(Tabs)
  .use(NavBar)
  .use(Empty)
  .use(Badge)
  .use(Sticky)
  .use(Collapse)
  .use(CollapseItem)
  .use(Popover)
  .use(Overlay)
  .use(PullRefresh)
  .use(ShareSheet)
  .use(Loading)
  .use(List)
  .use(CountDown)
  .use(Search);

// prop全局
Vue.prototype.$fn = fn;
Vue.prototype.$PAGE_API = PAGE_API;
Vue.prototype.$HTTP_API = HTTP_API;

Vue.config.productionTip = false;

window.App = new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
